<sn-drawer>
  <sn-drawer-header>
    <sn-icon-button icon="close" snDrawerClose snDrawerNavButton></sn-icon-button>
    <h3>{{ 'common.members' | t }}</h3>
  </sn-drawer-header>
  <sn-drawer-content style="overflow-y: hidden">
    <sn-channel-members-list *ngIf="sid" [sid]="sid"></sn-channel-members-list>
  </sn-drawer-content>
</sn-drawer>
